@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_675_174_997)
public val Res.string.shared_cost_note_labour_cost: StringResource by lazy {
      StringResource("string:shared_cost_note_labour_cost", "shared_cost_note_labour_cost", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 318465, 232),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 454517, 336),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 291828, 196),
      ))
    }

@delegate:ResourceContentHash(-1_427_671_384)
public val Res.string.shared_cost_note_net_sales: StringResource by lazy {
      StringResource("string:shared_cost_note_net_sales", "shared_cost_note_net_sales", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 318698, 234),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 454854, 322),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 292025, 190),
      ))
    }

@delegate:ResourceContentHash(-1_609_741_534)
public val Res.string.shared_cost_origin: StringResource by lazy {
      StringResource("string:shared_cost_origin", "shared_cost_origin", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 319061, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 455345, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 292316, 70),
      ))
    }

@delegate:ResourceContentHash(1_900_567_089)
public val Res.string.shared_cost_origin_hint: StringResource by lazy {
      StringResource("string:shared_cost_origin_hint", "shared_cost_origin_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 318933, 127),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 455177, 167),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 292216, 99),
      ))
    }

@delegate:ResourceContentHash(-1_235_327_393)
public val Res.string.shared_cost_part: StringResource by lazy {
      StringResource("string:shared_cost_part", "shared_cost_part", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 319187, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 455495, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 292434, 40),
      ))
    }

@delegate:ResourceContentHash(1_438_334_361)
public val Res.string.shared_cost_part_share: StringResource by lazy {
      StringResource("string:shared_cost_part_share", "shared_cost_part_share", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 319140, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 455448, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 292387, 46),
      ))
    }

@delegate:ResourceContentHash(-1_391_015_478)
public val Res.string.shared_cost_preview_fallback: StringResource by lazy {
      StringResource("string:shared_cost_preview_fallback", "shared_cost_preview_fallback", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 319228, 140),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 455536, 240),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 292475, 144),
      ))
    }

@delegate:ResourceContentHash(983_566_110)
public val Res.string.shared_cost_preview_title: StringResource by lazy {
      StringResource("string:shared_cost_preview_title", "shared_cost_preview_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 319369, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 455777, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 292620, 53),
      ))
    }

@delegate:ResourceContentHash(-1_126_682_094)
public val Res.string.shared_cost_saved: StringResource by lazy {
      StringResource("string:shared_cost_saved", "shared_cost_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 319427, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 455887, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 292674, 49),
      ))
    }

@delegate:ResourceContentHash(-1_755_733_666)
public val Res.string.shared_cost_split_label: StringResource by lazy {
      StringResource("string:shared_cost_split_label", "shared_cost_split_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 319485, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 455977, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 292724, 47),
      ))
    }

@delegate:ResourceContentHash(-300_331_493)
public val Res.string.shared_cost_start_month: StringResource by lazy {
      StringResource("string:shared_cost_start_month", "shared_cost_start_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 319537, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 456041, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 292772, 39),
      ))
    }

@delegate:ResourceContentHash(1_788_316_863)
public val Res.string.shared_cost_sum_missing_amount: StringResource by lazy {
      StringResource("string:shared_cost_sum_missing_amount", "shared_cost_sum_missing_amount", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 319585, 90),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 456077, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 292812, 66),
      ))
    }

@delegate:ResourceContentHash(-1_001_613_605)
public val Res.string.shared_cost_sum_missing_percent: StringResource by lazy {
      StringResource("string:shared_cost_sum_missing_percent", "shared_cost_sum_missing_percent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 319676, 119),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 456176, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 292879, 91),
      ))
    }

@delegate:ResourceContentHash(1_059_560_964)
public val Res.string.shared_cost_sum_ok: StringResource by lazy {
      StringResource("string:shared_cost_sum_ok", "shared_cost_sum_ok", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 319796, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 456324, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 292971, 66),
      ))
    }

@delegate:ResourceContentHash(-1_574_203_505)
public val Res.string.shared_cost_sum_over_amount: StringResource by lazy {
      StringResource("string:shared_cost_sum_over_amount", "shared_cost_sum_over_amount", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 319879, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 456435, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 293038, 71),
      ))
    }

@delegate:ResourceContentHash(1_279_356_325)
public val Res.string.shared_cost_sum_over_percent: StringResource by lazy {
      StringResource("string:shared_cost_sum_over_percent", "shared_cost_sum_over_percent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 319963, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 456543, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 293110, 84),
      ))
    }

@delegate:ResourceContentHash(-1_412_398_167)
public val Res.string.shared_cost_workplaces: StringResource by lazy {
      StringResource("string:shared_cost_workplaces", "shared_cost_workplaces", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 320052, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 456668, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 293195, 46),
      ))
    }

@delegate:ResourceContentHash(-11_986_770)
public val Res.string.shared_costs_add: StringResource by lazy {
      StringResource("string:shared_costs_add", "shared_costs_add", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 320158, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 456830, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 293309, 48),
      ))
    }

@delegate:ResourceContentHash(632_241_418)
public val Res.string.shared_costs_add_first: StringResource by lazy {
      StringResource("string:shared_costs_add_first", "shared_costs_add_first", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 320091, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 456719, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 293242, 66),
      ))
    }

@delegate:ResourceContentHash(1_217_403_743)
public val Res.string.shared_costs_count: StringResource by lazy {
      StringResource("string:shared_costs_count", "shared_costs_count", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 320211, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 456911, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 293358, 50),
      ))
    }

@delegate:ResourceContentHash(-1_418_760_125)
public val Res.string.shared_costs_empty: StringResource by lazy {
      StringResource("string:shared_costs_empty", "shared_costs_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 320458, 86),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 457338, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 293601, 66),
      ))
    }

@delegate:ResourceContentHash(-1_702_712_467)
public val Res.string.shared_costs_empty_hint: StringResource by lazy {
      StringResource("string:shared_costs_empty_hint", "shared_costs_empty_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 320266, 191),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 456986, 351),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 293409, 191),
      ))
    }

@delegate:ResourceContentHash(1_771_205_321)
public val Res.string.shared_costs_intro: StringResource by lazy {
      StringResource("string:shared_costs_intro", "shared_costs_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 320545, 274),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 457449, 490),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 293668, 254),
      ))
    }

@delegate:ResourceContentHash(927_391_449)
public val Res.string.shared_costs_manage: StringResource by lazy {
      StringResource("string:shared_costs_manage", "shared_costs_manage", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 320820, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 457940, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 293923, 67),
      ))
    }

@delegate:ResourceContentHash(-1_536_945_261)
public val Res.string.shared_costs_title: StringResource by lazy {
      StringResource("string:shared_costs_title", "shared_costs_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 320896, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 458064, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 293991, 54),
      ))
    }

@delegate:ResourceContentHash(1_140_081_110)
public val Res.string.shift: StringResource by lazy {
      StringResource("string:shift", "shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 322231, 21),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 459903, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 295222, 21),
      ))
    }

@delegate:ResourceContentHash(116_437_876)
public val Res.string.shift_break_add: StringResource by lazy {
      StringResource("string:shift_break_add", "shift_break_add", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 320951, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 458155, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 294046, 35),
      ))
    }

@delegate:ResourceContentHash(1_259_578_922)
public val Res.string.shift_break_from: StringResource by lazy {
      StringResource("string:shift_break_from", "shift_break_from", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 320995, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 458215, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 294082, 40),
      ))
    }

@delegate:ResourceContentHash(-1_098_714_994)
public val Res.string.shift_break_ongoing: StringResource by lazy {
      StringResource("string:shift_break_ongoing", "shift_break_ongoing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 321036, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 458264, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 294123, 87),
      ))
    }

@delegate:ResourceContentHash(-563_745_672)
public val Res.string.shift_break_remove: StringResource by lazy {
      StringResource("string:shift_break_remove", "shift_break_remove", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 321116, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 458400, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 294211, 42),
      ))
    }

@delegate:ResourceContentHash(770_064_176)
public val Res.string.shift_break_to: StringResource by lazy {
      StringResource("string:shift_break_to", "shift_break_to", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 321163, 26),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 458471, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 294254, 26),
      ))
    }

@delegate:ResourceContentHash(-1_979_998_326)
public val Res.string.shift_breaks: StringResource by lazy {
      StringResource("string:shift_breaks", "shift_breaks", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 321190, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 458502, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 294281, 28),
      ))
    }

@delegate:ResourceContentHash(-857_321_685)
public val Res.string.shift_not_clocked: StringResource by lazy {
      StringResource("string:shift_not_clocked", "shift_not_clocked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 321223, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 458543, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 294310, 45),
      ))
    }

@delegate:ResourceContentHash(-1_215_834_566)
public val Res.string.shift_note_from_manager: StringResource by lazy {
      StringResource("string:shift_note_from_manager", "shift_note_from_manager", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 321281, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 458625, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 294356, 63),
      ))
    }

@delegate:ResourceContentHash(-1_328_815_061)
public val Res.string.shift_note_hint: StringResource by lazy {
      StringResource("string:shift_note_hint", "shift_note_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 321341, 171),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 458713, 259),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 294420, 139),
      ))
    }

@delegate:ResourceContentHash(1_246_880_154)
public val Res.string.shift_note_label: StringResource by lazy {
      StringResource("string:shift_note_label", "shift_note_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 321513, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 458973, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 294560, 32),
      ))
    }

@delegate:ResourceContentHash(2_115_773_572)
public val Res.string.shift_note_nobody: StringResource by lazy {
      StringResource("string:shift_note_nobody", "shift_note_nobody", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 321550, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 459018, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 294593, 69),
      ))
    }

@delegate:ResourceContentHash(1_508_621_247)
public val Res.string.shift_note_removed: StringResource by lazy {
      StringResource("string:shift_note_removed", "shift_note_removed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 321624, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 459124, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 294663, 42),
      ))
    }

@delegate:ResourceContentHash(-42_276_129)
public val Res.string.shift_note_save: StringResource by lazy {
      StringResource("string:shift_note_save", "shift_note_save", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 321724, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 459264, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 294747, 35),
      ))
    }

@delegate:ResourceContentHash(797_166_644)
public val Res.string.shift_note_saved: StringResource by lazy {
      StringResource("string:shift_note_saved", "shift_note_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 321675, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 459195, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 294706, 40),
      ))
    }

@delegate:ResourceContentHash(1_508_139_698)
public val Res.string.shift_note_title: StringResource by lazy {
      StringResource("string:shift_note_title", "shift_note_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 321768, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 459332, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 294783, 68),
      ))
    }

@delegate:ResourceContentHash(1_156_004_396)
public val Res.string.shift_preset_afternoon: StringResource by lazy {
      StringResource("string:shift_preset_afternoon", "shift_preset_afternoon", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 321833, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 459421, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 294852, 42),
      ))
    }

@delegate:ResourceContentHash(-32_516_974)
public val Res.string.shift_preset_middle: StringResource by lazy {
      StringResource("string:shift_preset_middle", "shift_preset_middle", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 321884, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 459472, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 294895, 35),
      ))
    }

@delegate:ResourceContentHash(-115_988_708)
public val Res.string.shift_preset_morning: StringResource by lazy {
      StringResource("string:shift_preset_morning", "shift_preset_morning", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 321924, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 459520, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 294931, 40),
      ))
    }

@delegate:ResourceContentHash(-391_743_365)
public val Res.string.shift_presets_hint: StringResource by lazy {
      StringResource("string:shift_presets_hint", "shift_presets_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 321965, 130),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 459569, 178),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 294972, 122),
      ))
    }

@delegate:ResourceContentHash(729_893_547)
public val Res.string.shift_presets_title: StringResource by lazy {
      StringResource("string:shift_presets_title", "shift_presets_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 322096, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 459748, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 295095, 43),
      ))
    }

@delegate:ResourceContentHash(757_967_422)
public val Res.string.shift_times_actual: StringResource by lazy {
      StringResource("string:shift_times_actual", "shift_times_actual", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 322144, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 459808, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 295139, 42),
      ))
    }

@delegate:ResourceContentHash(1_397_219_097)
public val Res.string.shift_times_planned: StringResource by lazy {
      StringResource("string:shift_times_planned", "shift_times_planned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 322191, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 459855, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 295182, 39),
      ))
    }

@delegate:ResourceContentHash(-1_271_502_055)
public val Res.string.shortcut_close_dialog: StringResource by lazy {
      StringResource("string:shortcut_close_dialog", "shortcut_close_dialog", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 322253, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 459933, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 295244, 65),
      ))
    }

@delegate:ResourceContentHash(1_727_630_176)
public val Res.string.shortcut_confirm_dialog: StringResource by lazy {
      StringResource("string:shortcut_confirm_dialog", "shortcut_confirm_dialog", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 322315, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 460023, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 295310, 55),
      ))
    }

@delegate:ResourceContentHash(-1_173_840_618)
public val Res.string.shortcut_copy_cell: StringResource by lazy {
      StringResource("string:shortcut_copy_cell", "shortcut_copy_cell", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 322367, 102),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 460099, 158),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 295366, 102),
      ))
    }

@delegate:ResourceContentHash(1_145_022_793)
public val Res.string.shortcut_go_to: StringResource by lazy {
      StringResource("string:shortcut_go_to", "shortcut_go_to", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 322470, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 460258, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 295469, 38),
      ))
    }

@delegate:ResourceContentHash(-1_431_866_217)
public val Res.string.shortcut_grid_move: StringResource by lazy {
      StringResource("string:shortcut_grid_move", "shortcut_grid_move", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 322517, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 460317, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 295508, 50),
      ))
    }

@delegate:ResourceContentHash(495_428_228)
public val Res.string.shortcut_grid_open: StringResource by lazy {
      StringResource("string:shortcut_grid_open", "shortcut_grid_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 322588, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 460420, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 295559, 46),
      ))
    }

@delegate:ResourceContentHash(1_997_437_863)
public val Res.string.shortcut_grid_select: StringResource by lazy {
      StringResource("string:shortcut_grid_select", "shortcut_grid_select", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 322639, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 460491, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 295606, 48),
      ))
    }

@delegate:ResourceContentHash(-776_662_693)
public val Res.string.shortcut_grid_unassign: StringResource by lazy {
      StringResource("string:shortcut_grid_unassign", "shortcut_grid_unassign", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 322692, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 460564, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 295655, 66),
      ))
    }

@delegate:ResourceContentHash(1_443_380_346)
public val Res.string.shortcut_group_actions: StringResource by lazy {
      StringResource("string:shortcut_group_actions", "shortcut_group_actions", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 322771, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 460683, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 295722, 42),
      ))
    }

@delegate:ResourceContentHash(1_033_096_396)
public val Res.string.shortcut_group_dialogs: StringResource by lazy {
      StringResource("string:shortcut_group_dialogs", "shortcut_group_dialogs", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 322818, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 460722, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 295765, 54),
      ))
    }

@delegate:ResourceContentHash(-809_964_435)
public val Res.string.shortcut_group_month: StringResource by lazy {
      StringResource("string:shortcut_group_month", "shortcut_group_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 322869, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 460789, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 295820, 36),
      ))
    }

@delegate:ResourceContentHash(842_824_316)
public val Res.string.shortcut_group_navigation: StringResource by lazy {
      StringResource("string:shortcut_group_navigation", "shortcut_group_navigation", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 322910, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 460834, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 295857, 49),
      ))
    }

@delegate:ResourceContentHash(-944_292_834)
public val Res.string.shortcut_group_roster: StringResource by lazy {
      StringResource("string:shortcut_group_roster", "shortcut_group_roster", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 322956, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 460892, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 295907, 37),
      ))
    }

@delegate:ResourceContentHash(718_443_337)
public val Res.string.shortcut_new_roster: StringResource by lazy {
      StringResource("string:shortcut_new_roster", "shortcut_new_roster", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 322994, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 460938, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 295945, 43),
      ))
    }

@delegate:ResourceContentHash(2_118_429_408)
public val Res.string.shortcut_paste_cell: StringResource by lazy {
      StringResource("string:shortcut_paste_cell", "shortcut_paste_cell", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 323038, 103),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 460998, 167),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 295989, 107),
      ))
    }

@delegate:ResourceContentHash(1_852_476_307)
public val Res.string.shortcut_print: StringResource by lazy {
      StringResource("string:shortcut_print", "shortcut_print", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 323142, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 461166, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 296097, 30),
      ))
    }

@delegate:ResourceContentHash(1_330_508_745)
public val Res.string.shortcut_settings: StringResource by lazy {
      StringResource("string:shortcut_settings", "shortcut_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 323173, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 461213, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 296128, 37),
      ))
    }

@delegate:ResourceContentHash(1_422_880_375)
public val Res.string.shortcut_undo: StringResource by lazy {
      StringResource("string:shortcut_undo", "shortcut_undo", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 323215, 29),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 461271, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 296166, 29),
      ))
    }

@delegate:ResourceContentHash(-777_258_286)
public val Res.string.shortcut_zoom_in: StringResource by lazy {
      StringResource("string:shortcut_zoom_in", "shortcut_zoom_in", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 323245, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 461317, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 296196, 48),
      ))
    }

@delegate:ResourceContentHash(-2_027_626_167)
public val Res.string.shortcut_zoom_out: StringResource by lazy {
      StringResource("string:shortcut_zoom_out", "shortcut_zoom_out", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 323294, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 461386, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 296245, 53),
      ))
    }

@delegate:ResourceContentHash(-142_118_180)
public val Res.string.shortcut_zoom_reset: StringResource by lazy {
      StringResource("string:shortcut_zoom_reset", "shortcut_zoom_reset", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 323344, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 461452, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 296299, 63),
      ))
    }

@delegate:ResourceContentHash(-2_143_124_070)
public val Res.string.skeleton_add_existing: StringResource by lazy {
      StringResource("string:skeleton_add_existing", "skeleton_add_existing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 323408, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 461544, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 296363, 45),
      ))
    }

@delegate:ResourceContentHash(909_447_474)
public val Res.string.skeleton_add_one_shift: StringResource by lazy {
      StringResource("string:skeleton_add_one_shift", "skeleton_add_one_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 323462, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 461610, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 296409, 62),
      ))
    }

@delegate:ResourceContentHash(-110_327_344)
public val Res.string.skeleton_create_day_template: StringResource by lazy {
      StringResource("string:skeleton_create_day_template", "skeleton_create_day_template", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 323541, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 461701, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 296472, 64),
      ))
    }

@delegate:ResourceContentHash(-385_860_077)
public val Res.string.skeleton_create_new_definition: StringResource by lazy {
      StringResource("string:skeleton_create_new_definition", "skeleton_create_new_definition", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 323606, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 461786, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 296537, 66),
      ))
    }

@delegate:ResourceContentHash(-1_777_652_077)
public val Res.string.skeleton_custom_shift_subtitle: StringResource by lazy {
      StringResource("string:skeleton_custom_shift_subtitle", "skeleton_custom_shift_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 323677, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 461881, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 296604, 78),
      ))
    }

@delegate:ResourceContentHash(377_198_149)
public val Res.string.skeleton_day_off: StringResource by lazy {
      StringResource("string:skeleton_day_off", "skeleton_day_off", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 323760, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 461980, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 296683, 36),
      ))
    }

@delegate:ResourceContentHash(601_348_979)
public val Res.string.skeleton_day_summary: StringResource by lazy {
      StringResource("string:skeleton_day_summary", "skeleton_day_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 323801, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 462029, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 296720, 64),
      ))
    }

@delegate:ResourceContentHash(-1_252_542_154)
public val Res.string.skeleton_day_templates: StringResource by lazy {
      StringResource("string:skeleton_day_templates", "skeleton_day_templates", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 323866, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 462098, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 296785, 50),
      ))
    }

@delegate:ResourceContentHash(-56_276_764)
public val Res.string.skeleton_delete_and_remove: StringResource by lazy {
      StringResource("string:skeleton_delete_and_remove", "skeleton_delete_and_remove", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 323917, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 462157, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 296836, 82),
      ))
    }

@delegate:ResourceContentHash(2_041_646_056)
public val Res.string.skeleton_delete_shift_template: StringResource by lazy {
      StringResource("string:skeleton_delete_shift_template", "skeleton_delete_shift_template", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 324085, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 462389, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 297008, 74),
      ))
    }

@delegate:ResourceContentHash(1_946_865_528)
public val Res.string.skeleton_delete_shift_template_title: StringResource by lazy {
      StringResource("string:skeleton_delete_shift_template_title", "skeleton_delete_shift_template_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 323992, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 462276, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 296919, 88),
      ))
    }

@delegate:ResourceContentHash(1_916_947_772)
public val Res.string.skeleton_delete_template: StringResource by lazy {
      StringResource("string:skeleton_delete_template", "skeleton_delete_template", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 324265, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 462609, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 297192, 52),
      ))
    }

@delegate:ResourceContentHash(-1_709_865_077)
public val Res.string.skeleton_delete_template_confirm: StringResource by lazy {
      StringResource("string:skeleton_delete_template_confirm", "skeleton_delete_template_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 324160, 104),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 462492, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 297083, 108),
      ))
    }

@delegate:ResourceContentHash(-1_224_589_998)
public val Res.string.skeleton_delete_this_template: StringResource by lazy {
      StringResource("string:skeleton_delete_this_template", "skeleton_delete_this_template", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 324318, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 462682, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 297245, 65),
      ))
    }

@delegate:ResourceContentHash(-185_508_944)
public val Res.string.skeleton_done_availability_intro: StringResource by lazy {
      StringResource("string:skeleton_done_availability_intro", "skeleton_done_availability_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 324380, 196),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 462768, 312),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 297311, 180),
      ))
    }

@delegate:ResourceContentHash(1_690_575_165)
public val Res.string.skeleton_done_continue: StringResource by lazy {
      StringResource("string:skeleton_done_continue", "skeleton_done_continue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 324577, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 463081, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 297492, 42),
      ))
    }

@delegate:ResourceContentHash(1_543_930_004)
public val Res.string.skeleton_done_later: StringResource by lazy {
      StringResource("string:skeleton_done_later", "skeleton_done_later", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 324616, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 463124, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 297535, 35),
      ))
    }

@delegate:ResourceContentHash(1_013_567_731)
public val Res.string.skeleton_done_revenue_days: StringResource by lazy {
      StringResource("string:skeleton_done_revenue_days", "skeleton_done_revenue_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 324656, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 463172, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 297571, 78),
      ))
    }

@delegate:ResourceContentHash(-783_010_447)
public val Res.string.skeleton_done_revenue_fixed: StringResource by lazy {
      StringResource("string:skeleton_done_revenue_fixed", "skeleton_done_revenue_fixed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 324739, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 463283, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 297650, 55),
      ))
    }

@delegate:ResourceContentHash(1_337_939_277)
public val Res.string.skeleton_done_revenue_intro: StringResource by lazy {
      StringResource("string:skeleton_done_revenue_intro", "skeleton_done_revenue_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 324799, 175),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 463363, 247),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 297706, 159),
      ))
    }

@delegate:ResourceContentHash(1_923_394_859)
public val Res.string.skeleton_done_revenue_none: StringResource by lazy {
      StringResource("string:skeleton_done_revenue_none", "skeleton_done_revenue_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 324975, 146),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 463611, 266),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 297866, 166),
      ))
    }

@delegate:ResourceContentHash(-1_902_735_166)
public val Res.string.skeleton_done_revenue_title: StringResource by lazy {
      StringResource("string:skeleton_done_revenue_title", "skeleton_done_revenue_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 325122, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 463878, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 298033, 51),
      ))
    }

@delegate:ResourceContentHash(773_994_748)
public val Res.string.skeleton_done_revenue_total: StringResource by lazy {
      StringResource("string:skeleton_done_revenue_total", "skeleton_done_revenue_total", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 325178, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 463950, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 298085, 55),
      ))
    }

@delegate:ResourceContentHash(-273_338_797)
public val Res.string.skeleton_done_revenue_weekday: StringResource by lazy {
      StringResource("string:skeleton_done_revenue_weekday", "skeleton_done_revenue_weekday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 325242, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 464038, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 298141, 53),
      ))
    }

@delegate:ResourceContentHash(-1_402_792_583)
public val Res.string.skeleton_edit_shift_template: StringResource by lazy {
      StringResource("string:skeleton_edit_shift_template", "skeleton_edit_shift_template", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 325296, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 464092, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 298195, 72),
      ))
    }

@delegate:ResourceContentHash(387_286_317)
public val Res.string.skeleton_editing: StringResource by lazy {
      StringResource("string:skeleton_editing", "skeleton_editing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 325369, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 464197, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 298268, 44),
      ))
    }

@delegate:ResourceContentHash(1_327_748_915)
public val Res.string.skeleton_fill: StringResource by lazy {
      StringResource("string:skeleton_fill", "skeleton_fill", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 325818, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 464850, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 298717, 29),
      ))
    }

@delegate:ResourceContentHash(-293_888_735)
public val Res.string.skeleton_fill_days: StringResource by lazy {
      StringResource("string:skeleton_fill_days", "skeleton_fill_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 325602, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 464554, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 298505, 74),
      ))
    }

@delegate:ResourceContentHash(790_919_144)
public val Res.string.skeleton_fill_days_text: StringResource by lazy {
      StringResource("string:skeleton_fill_days_text", "skeleton_fill_days_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 325410, 191),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 464262, 291),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 298313, 191),
      ))
    }

@delegate:ResourceContentHash(-81_765_728)
public val Res.string.skeleton_filled: StringResource by lazy {
      StringResource("string:skeleton_filled", "skeleton_filled", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 325766, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 464790, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 298669, 47),
      ))
    }

@delegate:ResourceContentHash(1_020_761_379)
public val Res.string.skeleton_filled_none: StringResource by lazy {
      StringResource("string:skeleton_filled_none", "skeleton_filled_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 325677, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 464653, 136),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 298580, 88),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString38Resources(map: MutableMap<String, StringResource>) {
  map.put("shared_cost_note_labour_cost", Res.string.shared_cost_note_labour_cost)
  map.put("shared_cost_note_net_sales", Res.string.shared_cost_note_net_sales)
  map.put("shared_cost_origin", Res.string.shared_cost_origin)
  map.put("shared_cost_origin_hint", Res.string.shared_cost_origin_hint)
  map.put("shared_cost_part", Res.string.shared_cost_part)
  map.put("shared_cost_part_share", Res.string.shared_cost_part_share)
  map.put("shared_cost_preview_fallback", Res.string.shared_cost_preview_fallback)
  map.put("shared_cost_preview_title", Res.string.shared_cost_preview_title)
  map.put("shared_cost_saved", Res.string.shared_cost_saved)
  map.put("shared_cost_split_label", Res.string.shared_cost_split_label)
  map.put("shared_cost_start_month", Res.string.shared_cost_start_month)
  map.put("shared_cost_sum_missing_amount", Res.string.shared_cost_sum_missing_amount)
  map.put("shared_cost_sum_missing_percent", Res.string.shared_cost_sum_missing_percent)
  map.put("shared_cost_sum_ok", Res.string.shared_cost_sum_ok)
  map.put("shared_cost_sum_over_amount", Res.string.shared_cost_sum_over_amount)
  map.put("shared_cost_sum_over_percent", Res.string.shared_cost_sum_over_percent)
  map.put("shared_cost_workplaces", Res.string.shared_cost_workplaces)
  map.put("shared_costs_add", Res.string.shared_costs_add)
  map.put("shared_costs_add_first", Res.string.shared_costs_add_first)
  map.put("shared_costs_count", Res.string.shared_costs_count)
  map.put("shared_costs_empty", Res.string.shared_costs_empty)
  map.put("shared_costs_empty_hint", Res.string.shared_costs_empty_hint)
  map.put("shared_costs_intro", Res.string.shared_costs_intro)
  map.put("shared_costs_manage", Res.string.shared_costs_manage)
  map.put("shared_costs_title", Res.string.shared_costs_title)
  map.put("shift", Res.string.shift)
  map.put("shift_break_add", Res.string.shift_break_add)
  map.put("shift_break_from", Res.string.shift_break_from)
  map.put("shift_break_ongoing", Res.string.shift_break_ongoing)
  map.put("shift_break_remove", Res.string.shift_break_remove)
  map.put("shift_break_to", Res.string.shift_break_to)
  map.put("shift_breaks", Res.string.shift_breaks)
  map.put("shift_not_clocked", Res.string.shift_not_clocked)
  map.put("shift_note_from_manager", Res.string.shift_note_from_manager)
  map.put("shift_note_hint", Res.string.shift_note_hint)
  map.put("shift_note_label", Res.string.shift_note_label)
  map.put("shift_note_nobody", Res.string.shift_note_nobody)
  map.put("shift_note_removed", Res.string.shift_note_removed)
  map.put("shift_note_save", Res.string.shift_note_save)
  map.put("shift_note_saved", Res.string.shift_note_saved)
  map.put("shift_note_title", Res.string.shift_note_title)
  map.put("shift_preset_afternoon", Res.string.shift_preset_afternoon)
  map.put("shift_preset_middle", Res.string.shift_preset_middle)
  map.put("shift_preset_morning", Res.string.shift_preset_morning)
  map.put("shift_presets_hint", Res.string.shift_presets_hint)
  map.put("shift_presets_title", Res.string.shift_presets_title)
  map.put("shift_times_actual", Res.string.shift_times_actual)
  map.put("shift_times_planned", Res.string.shift_times_planned)
  map.put("shortcut_close_dialog", Res.string.shortcut_close_dialog)
  map.put("shortcut_confirm_dialog", Res.string.shortcut_confirm_dialog)
  map.put("shortcut_copy_cell", Res.string.shortcut_copy_cell)
  map.put("shortcut_go_to", Res.string.shortcut_go_to)
  map.put("shortcut_grid_move", Res.string.shortcut_grid_move)
  map.put("shortcut_grid_open", Res.string.shortcut_grid_open)
  map.put("shortcut_grid_select", Res.string.shortcut_grid_select)
  map.put("shortcut_grid_unassign", Res.string.shortcut_grid_unassign)
  map.put("shortcut_group_actions", Res.string.shortcut_group_actions)
  map.put("shortcut_group_dialogs", Res.string.shortcut_group_dialogs)
  map.put("shortcut_group_month", Res.string.shortcut_group_month)
  map.put("shortcut_group_navigation", Res.string.shortcut_group_navigation)
  map.put("shortcut_group_roster", Res.string.shortcut_group_roster)
  map.put("shortcut_new_roster", Res.string.shortcut_new_roster)
  map.put("shortcut_paste_cell", Res.string.shortcut_paste_cell)
  map.put("shortcut_print", Res.string.shortcut_print)
  map.put("shortcut_settings", Res.string.shortcut_settings)
  map.put("shortcut_undo", Res.string.shortcut_undo)
  map.put("shortcut_zoom_in", Res.string.shortcut_zoom_in)
  map.put("shortcut_zoom_out", Res.string.shortcut_zoom_out)
  map.put("shortcut_zoom_reset", Res.string.shortcut_zoom_reset)
  map.put("skeleton_add_existing", Res.string.skeleton_add_existing)
  map.put("skeleton_add_one_shift", Res.string.skeleton_add_one_shift)
  map.put("skeleton_create_day_template", Res.string.skeleton_create_day_template)
  map.put("skeleton_create_new_definition", Res.string.skeleton_create_new_definition)
  map.put("skeleton_custom_shift_subtitle", Res.string.skeleton_custom_shift_subtitle)
  map.put("skeleton_day_off", Res.string.skeleton_day_off)
  map.put("skeleton_day_summary", Res.string.skeleton_day_summary)
  map.put("skeleton_day_templates", Res.string.skeleton_day_templates)
  map.put("skeleton_delete_and_remove", Res.string.skeleton_delete_and_remove)
  map.put("skeleton_delete_shift_template", Res.string.skeleton_delete_shift_template)
  map.put("skeleton_delete_shift_template_title", Res.string.skeleton_delete_shift_template_title)
  map.put("skeleton_delete_template", Res.string.skeleton_delete_template)
  map.put("skeleton_delete_template_confirm", Res.string.skeleton_delete_template_confirm)
  map.put("skeleton_delete_this_template", Res.string.skeleton_delete_this_template)
  map.put("skeleton_done_availability_intro", Res.string.skeleton_done_availability_intro)
  map.put("skeleton_done_continue", Res.string.skeleton_done_continue)
  map.put("skeleton_done_later", Res.string.skeleton_done_later)
  map.put("skeleton_done_revenue_days", Res.string.skeleton_done_revenue_days)
  map.put("skeleton_done_revenue_fixed", Res.string.skeleton_done_revenue_fixed)
  map.put("skeleton_done_revenue_intro", Res.string.skeleton_done_revenue_intro)
  map.put("skeleton_done_revenue_none", Res.string.skeleton_done_revenue_none)
  map.put("skeleton_done_revenue_title", Res.string.skeleton_done_revenue_title)
  map.put("skeleton_done_revenue_total", Res.string.skeleton_done_revenue_total)
  map.put("skeleton_done_revenue_weekday", Res.string.skeleton_done_revenue_weekday)
  map.put("skeleton_edit_shift_template", Res.string.skeleton_edit_shift_template)
  map.put("skeleton_editing", Res.string.skeleton_editing)
  map.put("skeleton_fill", Res.string.skeleton_fill)
  map.put("skeleton_fill_days", Res.string.skeleton_fill_days)
  map.put("skeleton_fill_days_text", Res.string.skeleton_fill_days_text)
  map.put("skeleton_filled", Res.string.skeleton_filled)
  map.put("skeleton_filled_none", Res.string.skeleton_filled_none)
}
